import { Component, Vue } from 'vue-property-decorator'

const PREVIOUS_UNIT_LIST_POSITION_KEY = 'PREVIOUS_UNIT_LIST_POSITION'

@Component
export default class PositionListUnit extends Vue {
  protected setScrollPosition(path: string) {
    const uid = Vue.prototype.$cookies.get('authGdls').uid
    if (!uid) return
    const previousPath = JSON.parse(localStorage.getItem(PREVIOUS_UNIT_LIST_POSITION_KEY) || '{}')
    localStorage.setItem(
      PREVIOUS_UNIT_LIST_POSITION_KEY,
      JSON.stringify({
        ...previousPath,
        [uid]: { ...previousPath[uid], [path]: Math.floor(window.scrollY) },
      })
    )
  }

  protected scrollToPrePosition(path: string) {
    const previousPath = JSON.parse(localStorage.getItem(PREVIOUS_UNIT_LIST_POSITION_KEY) || '{}')
    const uid = Vue.prototype.$cookies.get('authGdls')?.uid
    if (!uid) return
    const previousPosition = previousPath?.[uid]?.[path]
    if (previousPosition) {
      window.scrollTo({
        top: previousPosition,
        behavior: 'smooth',
      })
    }
  }
}
